import React from 'react'
import { injectGlobal } from 'styled-components'
import loadImage from 'blueimp-load-image'
import FontFaceObserver from 'fontfaceobserver'
import { all, map } from 'awaity/esm'
import leftPad from 'left-pad'
// import { FormattedMessage } from 'react-intl'
import { Modal } from 'antd'

class VirtualBib extends React.Component {
  state = {
    imgUrl: ''
  }
  getBase64Bib = async () => {
    const { fonts = [], backgroundUrl, nameStyle, numberStyle, name, number, numberDigits } = this.props
    const bibNumber = leftPad(number, numberDigits, '0')
    const fontsCss = fonts.map(({ fontFamily, fontSrcUrl }) =>
      `@font-face {
  font-family: "${fontFamily}";
  src: url(${fontSrcUrl});
}`
    ).join('\n')
    injectGlobal`${fontsCss}`

    const imageLoaded$ = new Promise((resolve, reject) => {
      loadImage(backgroundUrl, canvas => {
        if (canvas.type === 'error') {
          return reject(new Error(`Loading image ${backgroundUrl} failed`))
        }
        resolve(canvas)
      }, {
        canvas: true,
        crossOrigin: 'annonymous'
      })
    })

    const fontsLoaded$ = map(fonts, ({ fontFamily }) => {
      const font = new FontFaceObserver(fontFamily)
      return font.load()
    })
    try {
      const [canvas] = await all([imageLoaded$, fontsLoaded$])
      const ctx = canvas.getContext('2d')
  
      ctx.font = numberStyle.font
      ctx.textAlign = numberStyle.textAlign
      ctx.fillStyle = numberStyle.fillStyle
      ctx.fillText(bibNumber, numberStyle.left, numberStyle.top)
  
      ctx.font = nameStyle.font
      ctx.textAlign = nameStyle.textAlign
      ctx.fillStyle = nameStyle.fillStyle
      ctx.fillText(name, nameStyle.left, nameStyle.top)
      const imgUrl = canvas.toDataURL('image/jpeg')
      return imgUrl
    } catch (error) {
      console.log(error)
      return null
    }
  }

  showBib = async () => {
    const imgUrl = await this.getBase64Bib()
    // return <img src={imgUrl} alt='e-Bib' style={{ maxWidth: '100%' }}/>
    Modal.info({
      maskClosable: true,
      content: <img src={imgUrl} alt='e-Bib' style={{ maxWidth: '100%' }}/>
    })
  }

  async componentWillMount () {
    const imgUrl = await this.getBase64Bib()
    this.setState({ imgUrl })
  }

  render () {
    // const imgUrl = this.getBase64Bib()
    // console.log(imgUrl)
    return <React.Fragment>
      {/* <Button onClick={this.showBib} size="small" style={{marginBottom: '10px'}}>
        <FormattedMessage id="app.view" defaultMessage="View" values={{ text: 'e-Bib' }}/>
      </Button> */}
      <div>

        {this.state.imgUrl && <img src={this.state.imgUrl} onClick={this.showBib} alt='e-Bib' style={{ maxWidth: '80%' }}/>}
      </div>
    </React.Fragment>
  }
}

export default VirtualBib



// WEBPACK FOOTER //
// ./src/App/components/VirtualBib.js